import React, { Component } from "react";
import _ from 'i18n';
import {Col, Row} from "antd";
import {connect} from "react-redux";


class EventDataTableRowFeetching extends Component {


  render() {
    const { appType } = this.props.eventStatsFilter;
    return (
      <div>
        {[...Array(5)].map((x, i) =>
          <div className={"event-stats-row-container gradiant"}>
            <Row className="event-stats-row" justify="space-around">
              <Col
                span={1} >
                <div
                  className={'event-stats-activity-row-border ' +
                  (appType == 'registering' ? 'blue' :
                    (appType == 'cycle_registering' ? 'purple' :
                      (appType == 'all_in' ? 'orange' : 'grey')))}></div>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EventDataTableRowFeetching);





// WEBPACK FOOTER //
// ./app/components/feetching/EventDataTableRowFeetching.js